export enum TmsType {
  BLUJAY = 'BLUJAY',
  BLUEYONDER = 'BLUEYONDER',
  LOCAL = 'LOCAL',
}
